import React from 'react';
import './FooterSocialList.scss';
import Twitter from '../../UI/Icons/Twitter';
import Youtube from '../../UI/Icons/Youtube';
import Instagram from '../../UI/Icons/Instagram';
import Facebook from '../../UI/Icons/Facebook';
import LinkedIn from '../../UI/Icons/LinkedIn';

/**
 * Renders the social links list
 * @param {array} socialLinks - the social links
 * @returns {JSX.Element}
 * @constructor
 */
const FooterSocialList = ({ socialLinks }) => {
  const getSocialType = (type) => {
    switch (true) {
      case type === 'twitter':
        return <Twitter />;
      case type === 'youtube':
        return <Youtube />;
      case type === 'instagram':
        return <Instagram />;
      case type === 'facebook':
        return <Facebook />;
      case type === 'linkedin':
        return <LinkedIn />;
    }
  };

  const renderSocialLinks = (links) =>
    links.map((link, i) => (
      <li key={`social-link-${i}`} className="c-footer-social-list__list-item">
        <a href={link.url} target="_blank" rel="noopener noreferrer">
          {getSocialType(link.type)}
        </a>
      </li>
    ));

  return (
    <div className="c-footer-social-list">
      <ul className="c-footer-social-list__list">{renderSocialLinks(socialLinks)}</ul>
    </div>
  );
};

export default FooterSocialList;
